import script from "./NotificationManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationManager.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationManager.vue?vue&type=style&index=0&id=72678982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72678982"]])

export default __exports__